/**
 * Keeps the original behavior:
 * - existingUsernames is an Array (not Set)
 * - uses .includes() and .push()
 * - caller is responsible for pushing account usernames before calling this
 *
 * @param {{ firstName: string, lastName: string }} employee
 * @param {string[]} existingUsernames - mutated in place
 * @returns {string}
 */
export function generateUniqueUsername(employee, existingUsernames) {
    const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
    const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase();
    let baseUsername = firstNameInitial + lastNameLower;

    let uniqueUsername = baseUsername;
    let counter = 1;

    while (existingUsernames.includes(uniqueUsername)) {
        uniqueUsername = `${baseUsername}${counter}`;
        counter += 1;
    }

    existingUsernames.push(uniqueUsername); // ← original behavior: push inside generator
    return uniqueUsername;
}